module.exports = __webpack_public_path__ + "static/img/posx_2.c93c38d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/posx_2.jpg
// module id = XRs3
// module chunks = 2